import React from 'react';
import Rate from './Rate';
import { connect } from 'react-redux';
import { getRate, calcRate } from '../../redux/rateReducer';

class RateContainer extends React.Component {

    componentDidMount() {
        this.props.getRate(this.props.base, this.props.currency);
    }

    render() {
        return (
            <Rate
                base={this.props.base}
                currency={this.props.currency}
                currencyRate={this.props.currencyRate}
                calculated={this.props.calculated}
                calcRate={this.props.calcRate}
            />
        )
    }
}

let mapStateToProps = (state) => ({
    base: state.ratePage.base,
    currency: state.ratePage.currency,
    currencyRate: state.ratePage.currencyRate,
    calculated: state.ratePage.calculated
});

export default connect(mapStateToProps, { getRate, calcRate })(RateContainer);